<template>
    <div class="stamp-container">
        <span id="stamp-text">{{month}} {{description}}</span>
        <img src="/assets/images/device-stamp.svg" alt="promo-stamp">
    </div>
</template>

<script>

export default {
  name: 'delayed-promotion-stamp',
  props: {
    description: String,
    month: Number
  }
}
</script>

<style scoped lang="scss">

.stamp-container {
    height: 100px;
    position: relative;
    img {
        width: 90px;
        height: 90px;
    }
    @media (#{map-get($breakpoints, sm)}) {
      margin-left: auto;
    }

    #stamp-text {
        position: absolute;
        top: 33%;
        left: 5%;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 1px;
        color: $white;
        text-transform: uppercase;
    }
}
</style>
